export const AnswerCardLang = {
    complete: 'تکمیل شده',
    inComplete: 'تکمیل نشده',
    answer: 'پاسخ',
};
